import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star } from "lucide-react";
import { Logo } from "@/components/shell/Logo";
import { api, messageErreur } from "@/lib/api";

export default function Satisfaction() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [erreur, setErreur] = useState("");
  const [note, setNote] = useState(0);
  const [commentaire, setCommentaire] = useState("");
  const [fini, setFini] = useState(false);
  useEffect(() => { api.get(`/satisfaction/${token}`).then((r) => setD(r.data)).catch((e) => setErreur(messageErreur(e))); }, [token]);
  const envoyer = () => api.post(`/satisfaction/${token}`, { note, commentaire }).then(() => setFini(true)).catch((e) => setErreur(messageErreur(e)));
  return (
    <div className="min-h-screen px-4 py-6 max-w-lg mx-auto space-y-4" data-testid="page-satisfaction">
      <Logo />
      {erreur && <p className="at-card p-5 font-semibold" style={{ color: "var(--danger)" }} data-testid="satisfaction-error">{erreur}</p>}
      {d && (fini || d.deja ? <p className="at-card p-5 text-lg font-bold" data-testid="satisfaction-thanks">Merci pour votre avis !</p> : (
        <>
          <h1 className="text-3xl font-bold tracking-tight">Bonjour {d.prenom}, êtes-vous satisfait ?</h1>
          <p className="at-muted">Installation {d.operation} par {d.partenaire}.</p>
          <div className="flex justify-between gap-1" data-testid="satisfaction-stars">
            {[1, 2, 3, 4, 5].map((i) => <button key={i} type="button" onClick={() => setNote(i)} className="w-14 h-14 flex items-center justify-center" aria-label={`${i} sur 5`} data-testid={`satisfaction-star-${i}`}><Star size={36} fill={i <= note ? "var(--accent)" : "none"} style={{ color: "var(--accent)" }} /></button>)}
          </div>
          <textarea value={commentaire} onChange={(e) => setCommentaire(e.target.value)} rows={3} maxLength={1000} placeholder="Un commentaire ? (facultatif)" className="at-input !h-auto py-2" data-testid="satisfaction-comment" />
          <button type="button" disabled={!note} onClick={envoyer} className="at-btn at-btn-primary w-full !min-h-[56px]" data-testid="satisfaction-submit">Envoyer mon avis</button>
        </>
      ))}
    </div>
  );
}
